export const CONTACT = {
  person: "Martinkó Miklós",
  phoneDisplay: "+36 20 995 9700",
  phoneHref: "tel:+36209959700",
  email: "tetoklinika@gmail.com",
  emailHref: "mailto:tetoklinika@gmail.com",
  company: "GRUDA-BAU Kft.",
  address: "9022 Győr, Bajcsy-Zsilinszky u. 59. fszt.",
  taxNumber: "22780267-2-08",
  regNumber: "08-09-020290",
  mapEmbed:
    "https://maps.google.com/maps?width=100%25&height=600&hl=hu&q=9022%20Gy%C5%91r%2C%20Bajcsy-Zsilinszky%20u.%2059.&t=&z=15&ie=UTF8&iwloc=B&output=embed",
};

export const IMAGES = {
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_roofing-solutions-15/artifacts/epzg9emp_logo.png",
  hero: "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBob3VzZSUyMHJvb2YlMjBleHRlcmlvcnxlbnwwfHx8fDE3ODQ4Nzg3Nzl8MA&ixlib=rb-4.1.0&q=85",
  about:
    "https://images.pexels.com/photos/7788269/pexels-photo-7788269.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  serviceHighlight:
    "https://images.pexels.com/photos/36884223/pexels-photo-36884223.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  beforeOld:
    "https://customer-assets-agu9un31.emergentagent.net/job_roofing-solutions-15/artifacts/bd8ulud2_684820241_122216399252564331_4344272307044530966_n.webp",
  afterNew:
    "https://customer-assets-agu9un31.emergentagent.net/job_roofing-solutions-15/artifacts/vukmnapu_682942838_122216399282564331_6845114166720459747_n.webp",
  ref1: "https://images.pexels.com/photos/13771880/pexels-photo-13771880.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  ref2: "https://images.unsplash.com/photo-1632759145351-1d592919f522?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxyb29mJTIwcmVwYWlyJTIwd29ya2VyfGVufDB8fHx8MTc4NDg3ODc3OXww&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "Szolgáltatások", id: "szolgaltatasok" },
  { label: "Rólunk", id: "rolunk" },
  { label: "Munkafolyamat", id: "munkafolyamat" },
  { label: "Kapcsolat", id: "kapcsolat" },
];

export const TRUST_BADGES = [
  "Több mint 20 év szakmai tapasztalat",
  "Minőségi osztrák alapanyagok",
  "Precíz, szakszerű kivitelezés",
];

export const PROBLEMS = [
  {
    title: "Beázás és nedvesedés",
    desc: "A tetőn átszivárgó víz idővel komoly szerkezeti és belső károkat okozhat.",
    icon: "Droplets",
  },
  {
    title: "Sérült vagy hiányzó tetőfedés",
    desc: "A megbomlott vagy hiányzó fedőanyag szabaddá teszi a tetőszerkezetet.",
    icon: "LayoutPanelTop",
  },
  {
    title: "Elöregedett pala vagy cserép",
    desc: "Az évtizedek alatt elhasználódott fedés elveszíti védőfunkcióját.",
    icon: "Hammer",
  },
  {
    title: "Hibás ereszcsatorna és vízelvezetés",
    desc: "A nem megfelelő vízelvezetés a homlokzatot és az alapokat is veszélyezteti.",
    icon: "Waves",
  },
];

export const SERVICES = [
  {
    id: "tetofedes",
    title: "Tetőfedés",
    desc: "Régi és új épületek teljes körű tetőfedése cseréppel, palával vagy cserepeslemezzel, helyszíni felméréssel és szaktanácsadással.",
    icon: "Home",
    size: "large",
  },
  {
    id: "tetojavitas",
    title: "Tetőjavítás és tetőfelújítás",
    desc: "Sérült, elöregedett vagy beázó tetők javítása, részleges vagy teljes felújítása, bizonyos esetekben bontás nélküli technológiával.",
    icon: "Wrench",
    size: "normal",
  },
  {
    id: "lemezteto",
    title: "Lemeztető készítés",
    desc: "Könnyű, tartós és időjárásálló lemezfedések kialakítása új vagy meglévő tetőszerkezeteken.",
    icon: "Layers",
    size: "normal",
  },
  {
    id: "badogos",
    title: "Bádogos munkák",
    desc: "Ereszcsatornák, tetőszegélyek, vápák, párkányok és egyéb vízelvezető vagy tetővédő bádogelemek elkészítése és javítása.",
    icon: "Ruler",
    size: "normal",
  },
  {
    id: "palateto",
    title: "Palatető felújítás",
    desc: "Sík- és hullámpalás tetők bontás nélküli felújítása vízszigetelő bitumenes fedéssel, többféle mintában és színben.",
    icon: "ShieldCheck",
    size: "normal",
  },
  {
    id: "cserepeslemez",
    title: "Cserepeslemez felrakása",
    desc: "Könnyűszerkezetű, klasszikus cserépmintázatú lemezfedés telepítése, akár a meglévő tető bontása nélkül.",
    icon: "Grid3x3",
    size: "normal",
  },
  {
    id: "tetoszigeteles",
    title: "Tetőszigetelés",
    desc: "Lapostetők víz- és hőszigetelése, valamint belső, nyitott vagy zárt cellás szórt habszigetelés kialakítása.",
    icon: "Thermometer",
    size: "large",
  },
];

export const WHY_US = [
  {
    title: "Több mint 20 év tapasztalat",
    desc: "Több évtizedes szakmai tapasztalattal vállalunk tetőfedési, tetőjavítási, tetőfelújítási és bádogos munkákat.",
    icon: "Award",
  },
  {
    title: "Felkészült szakemberek",
    desc: "A munkálatokat tapasztalt, szakmailag felkészült kivitelezők végzik.",
    icon: "Users",
  },
  {
    title: "Minőségi alapanyagok",
    desc: "A kivitelezés során megbízható, minőségi osztrák alapanyagokkal dolgozunk.",
    icon: "BadgeCheck",
  },
  {
    title: "Precíz kivitelezés",
    desc: "Nagy hangsúlyt fektetünk a pontos munkavégzésre, a részletekre és a tartós végeredményre.",
    icon: "Target",
  },
  {
    title: "Többféle tetőmegoldás",
    desc: "Cserép-, pala- és lemezfedésekkel, valamint víz- és hőszigetelési megoldásokkal is foglalkozunk.",
    icon: "Layers3",
  },
  {
    title: "Széles működési terület",
    desc: "Nyugat-Magyarországon, a Dunántúl több megyéjében, Pest megyében és Szlovákia területén is vállalunk munkákat.",
    icon: "MapPin",
  },
];

export const PROCESS = [
  {
    title: "Kapcsolatfelvétel",
    desc: "Az érdeklődő telefonon, e-mailben vagy az ajánlatkérő űrlapon keresztül felveszi velünk a kapcsolatot.",
  },
  {
    title: "Igények egyeztetése",
    desc: "Röviden átbeszéljük a tető jelenlegi állapotát, a tapasztalt problémákat és az elvégzendő munkát.",
  },
  {
    title: "Helyszíni felmérés",
    desc: "Szükség esetén személyesen felmérjük a tető állapotát és meghatározzuk a megfelelő műszaki megoldást.",
  },
  {
    title: "Ajánlatadás",
    desc: "A felmérés és az egyeztetett igények alapján személyre szabott ajánlat készül.",
  },
  {
    title: "Kivitelezés",
    desc: "A megállapodás szerint elvégezzük a szükséges tetőfedési, javítási, felújítási, bádogos vagy szigetelési munkákat.",
  },
];

export const REFERENCES = [
  { src: "https://www.tetoklinika.hu/uploads/1_1.jpg", label: "Tetőklinika referencia" },
  { src: "https://www.tetoklinika.hu/uploads/1_2.jpg", label: "Tetőklinika referencia" },
  { src: "https://www.tetoklinika.hu/uploads/1_3.jpg", label: "Tetőklinika referencia" },
  { src: "https://www.tetoklinika.hu/uploads/1_4.jpg", label: "Tetőklinika referencia" },
  { src: "https://www.tetoklinika.hu/uploads/1_5.jpg", label: "Tetőklinika referencia" },
  { src: "https://www.tetoklinika.hu/uploads/1_6.jpg", label: "Tetőklinika referencia" },
  { src: "https://www.tetoklinika.hu/uploads/1_7.jpg", label: "Tetőklinika referencia" },
  { src: "https://www.tetoklinika.hu/uploads/1_8.jpg", label: "Tetőklinika referencia" },
  { src: "https://www.tetoklinika.hu/uploads/1_9.jpg", label: "Tetőklinika referencia" },
  { src: "https://www.tetoklinika.hu/uploads/1_10.jpg", label: "Tetőklinika referencia" },
  { src: "https://www.tetoklinika.hu/uploads/1_11.jpg", label: "Tetőklinika referencia" },
  { src: "https://www.tetoklinika.hu/uploads/1_12.jpg", label: "Tetőklinika referencia" },
];

export const FAQS = [
  {
    q: "Milyen tetőfedő anyagokkal dolgoznak?",
    a: "Cserép-, pala- és cserepeslemez-fedések kivitelezésével és felújításával is foglalkozunk. A megfelelő megoldás az épület adottságaitól, a tetőszerkezet állapotától és a megrendelő igényeitől függ.",
  },
  {
    q: "Minden régi tető felújítható bontás nélkül?",
    a: "Nem. A bontás nélküli felújítás lehetősége a meglévő tető típusától és állapotától függ. A megfelelő technológiát helyszíni felmérés után lehet meghatározni.",
  },
  {
    q: "Beázó tető javítását is vállalják?",
    a: "Igen, sérült, elöregedett és beázó tetők részleges javításával, valamint szükség esetén teljes felújításával is foglalkozunk.",
  },
  {
    q: "Palatető felújítását is vállalják?",
    a: "Igen, sík- és hullámpalás tetők felújításával is foglalkozunk. Bizonyos esetekben a meglévő pala bontása nélkül is kialakítható új, vízszigetelő fedés.",
  },
  {
    q: "Cserepeslemez felrakható a meglévő tetőre?",
    a: "Bizonyos tetőszerkezeteknél igen, de ezt minden esetben a tető állapota és műszaki adottságai alapján kell eldönteni.",
  },
  {
    q: "Milyen bádogos munkákat végeznek?",
    a: "Ereszcsatornák, tetőszegélyek, vápák, párkányok és egyéb vízelvezető vagy tetővédő bádogelemek készítését és javítását is vállaljuk.",
  },
  {
    q: "Lapostetők szigetelésével is foglalkoznak?",
    a: "Igen, lapostetők víz- és hőszigetelését, valamint belső, nyitott vagy zárt cellás szórt habszigetelést is vállalunk.",
  },
  {
    q: "Hol vállalnak munkát?",
    a: "Nyugat-Magyarországon, a Dunántúl több megyéjében, Pest megyében és Szlovákia területén is dolgozunk. A konkrét helyszínről előzetes egyeztetés szükséges.",
  },
  {
    q: "Hogyan kérhetek ajánlatot?",
    a: "Ajánlatot telefonon, e-mailben vagy a weboldalon található ajánlatkérő űrlap kitöltésével lehet kérni.",
  },
  {
    q: "Mi szükséges az ajánlatkéréshez?",
    a: "Kérjük, adja meg az ingatlan helyszínét, a szükséges szolgáltatást, a tapasztalt problémát, valamint lehetőség szerint töltsön fel néhány képet a tetőről. A pontos műszaki tartalomhoz helyszíni felmérésre is szükség lehet.",
  },
];

export const BRANDS = ["VILLAS", "Bramac", "Creaton", "Lindab", "Terran", "Blachotrapez"];

export const SERVICE_OPTIONS = [  "Tetőfedés",
  "Tetőjavítás",
  "Tetőfelújítás",
  "Lemeztető készítés",
  "Bádogos munkák",
  "Palatető felújítás",
  "Cserepeslemez felrakása",
  "Tetőszigetelés",
  "Egyéb",
];
